import { render } from "./RGPD.vue?vue&type=template&id=009baa4c&scoped=true"
import script from "./RGPD.vue?vue&type=script&lang=js"
export * from "./RGPD.vue?vue&type=script&lang=js"

import "./RGPD.vue?vue&type=style&index=0&id=009baa4c&scoped=true&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009baa4c"]])

export default __exports__